const PublicDomain = () => import('@/modules/landing-pages/views/PublicDomain')
const Promo = () => import('@/modules/landing-pages/views/Promo')
const Jornada = () => import('@/modules/landing-pages/views/Jornada')
const ScrivPro = () => import('@/modules/landing-pages/views/ScrivPro')
export default [
  {
    path: '/scriv-classicos',
    name: 'landing-pages.public-domain',
    component: PublicDomain
  },
  {
    path: '/promo/livros',
    name: 'landing-pages.promo',
    component: Promo
  },
  {
    path: '/jornada',
    name: 'landing-pages.jornada',
    component: Jornada
  },
  {
    path: '/scriv-pro',
    name: 'landing-pages.scriv-pro',
    component: ScrivPro
  }
]
